import { Layout } from '@components/Layout';
import PermissionGate from '@components/upercut-permissions/PermissionGate';
import { OptionsProvider } from '@modules/talents/context/options-context';
import TalentSearchModule from './TalentSearchModule';

const TalentSearchPage = () => {
  return (
    <Layout
      breadcrumbs={[
        { label: 'Tableau de bord', href: '/', value: 'dashboard' },
        { label: 'Recherche de Talents', href: '/talent-search', value: 'talent-search' },
      ]}
      heading="Recherche de Talents"
    >
      <OptionsProvider>
        <PermissionGate permission="talents:read">
          <TalentSearchModule />
        </PermissionGate>
      </OptionsProvider>
    </Layout>
  );
};

export default TalentSearchPage;
